var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col col-12" }, [
      _c("input", {
        staticClass: "form-control",
        attrs: { readonly: "" },
        domProps: { value: _vm.value }
      })
    ]),
    _c("div", { staticClass: "col-md-2 mt-1" }, [
      _c(
        "div",
        { staticClass: "btn-group" },
        [
          _c("DownloadS3File", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip",
                value: "Descargar",
                expression: "'Descargar'"
              }
            ],
            attrs: {
              path: _vm.value,
              name: _vm.param + ".html",
              force: "si",
              "style-class": "btn btn-outline-secondary"
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function(props) {
                  return [
                    !props.downloading
                      ? _c("span", { staticClass: "material-icons" }, [
                          _vm._v("cloud_download")
                        ])
                      : _vm._e(),
                    props.downloading
                      ? _c("b-spinner", {
                          attrs: { variant: "primary", size: "18" }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm.hasPermisionSave
            ? _c("UploadFileToS3", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: "Cargar",
                    expression: "'Cargar'"
                  }
                ],
                attrs: { "upload-to": _vm.attachmentUrl },
                on: { input: _vm.uploadLocalFile },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "button",
                      fn: function(props) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { disabled: props.progress.enabled }
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("cloud_upload")
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3294952022
                )
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }